module.exports = __webpack_public_path__ + "img/img11.395cb74c.svg";